import { ProfiBazaAPIModels } from 'services/src/profiBazaAPI';

export const mappings = new Map<ProfiBazaAPIModels.RoleCategory, string>([
	[ProfiBazaAPIModels.RoleCategory.CENTRAL, 'centralny'],
	[ProfiBazaAPIModels.RoleCategory.LOCAL, 'lokalny'],
]);

export const map = (value: ProfiBazaAPIModels.RoleCategory): string =>
	mappings.get(value) ?? '';
